import { FC } from 'react';
import { Typography } from '@mui/material';

import { CardContent, CardHeader } from './Card';
import CollapsibleCard, { CollapsibleCardProps } from '../../../../../components/Card/CollapsibleCard/CollapsibleCard';
import CollapsibleCardExpandArea from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandArea';
import CollapsibleCardExpandButton from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandButton';
import Column from '../../../../../components/Column';
import Row from '../../../../../components/Row';

import { AdCreative } from '../../../../../types/AmazonAds';
import CreativePreview from '../../../../../components/Creative/CreativePreview';
import DspAdCreativeUtils from '../../../../../utils/DspAdCreativeUtils';

interface CampaignCreativeCardProps {
    dspAdCreative: AdCreative;
    slotProps?: {
        collapsibleCard?: Partial<CollapsibleCardProps>;
    };
}

const CampaignCreativeCard: FC<CampaignCreativeCardProps> = ({ dspAdCreative, slotProps = {} }) => {
    return (
        <CollapsibleCard defaultExpanded {...slotProps?.collapsibleCard}>
            <CardHeader
                title={
                    <Row alignItems="center" gap={1}>
                        <Typography variant="body1">{dspAdCreative.name}</Typography>
                    </Row>
                }
                action={<CollapsibleCardExpandButton />}
            />
            <CollapsibleCardExpandArea>
                <CardContent>
                    <Column gap={3}>
                        <CreativePreview
                            hideHeader
                            adCreatives={[dspAdCreative]}
                            parseXML={DspAdCreativeUtils.fetchVastXML}
                            slotProps={{
                                paper: {
                                    variant: 'elevation',
                                    elevation: 0,
                                },
                            }}
                        />
                    </Column>
                </CardContent>
            </CollapsibleCardExpandArea>
        </CollapsibleCard>
    );
};

export default CampaignCreativeCard;
